const state = {
  registration_button: {
    heading: {
      id: '',
      en: '',
    },
    button_text: {
      id: '',
      en: '',
    },
    button_url: '',
  },
};

export default state;
